// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"b776b540","703":"2f8ea20b","759":"79bd9cab"}[chunkId] + ".chunk.js";
};